import { c as _c } from "react/compiler-runtime";
import { HostType } from '@repo/types/host';
import { useEffect, useState } from 'react';
const remoteMobileMapsToolbarTopOffset = 32;
export function getMobileMapsEmbedConfig(search: string | URLSearchParams) {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const toolbarTopOffset = Number(params.get('mobileToolbarTopOffset') ?? 0);
  const parsedToolbarTopOffset = Number.isFinite(toolbarTopOffset) ? Math.max(0, toolbarTopOffset) : 0;
  const enabled = params.get('embedContext') === 'mobile_maps';
  return {
    enabled,
    toolbarTopOffset: enabled && params.get('hostType') === HostType.REMOTE ? Math.max(parsedToolbarTopOffset, remoteMobileMapsToolbarTopOffset) : parsedToolbarTopOffset
  };
}
export function useMobileMapsEmbed() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      enabled: false,
      toolbarTopOffset: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [mobileMapsEmbed, setMobileMapsEmbed] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMobileMapsEmbed(getMobileMapsEmbedConfig(window.location.search));
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return mobileMapsEmbed;
}